import { useState, useEffect } from "react";
import WMSCapabilities from "ol/format/WMSCapabilities.js";

const useWMSLayers = (wmtsUrl) => {
  const [layers, setLayers] = useState(null);
  const urlHttpRegexp = new RegExp(/^((http|https):\/\/)/);

  useEffect(() => {
    async function getWMSLayers() {
      try {
        const response = await fetch(
          urlHttpRegexp.test(wmtsUrl) ? wmtsUrl : `https://${wmtsUrl}`
        );
        const text = await response.text();
        const parser = new WMSCapabilities();
        const data = parser.read(text);

        const layers = data?.Capability?.Layer?.Layer?.map((layer, index) => {
          return {
            ...layer,
            name: layer.Name,
            parentLayerId: -1,
            id: index,
          };
        });

        setLayers(layers);
      } catch (err) {
        console.error(new Error("[OLMap] - could not fetch WMTS layers:", err));
      }
    }

    if (wmtsUrl) getWMSLayers();
  }, [wmtsUrl]);

  return layers || [];
};

export default useWMSLayers;
